import React, {useEffect, useRef, useState,useMemo} from "react";
import {DeleteItemsApi} from "../../../../reduxToolkit/Commons/CommonsApi";
import {useDispatch, useSelector} from "react-redux";
import {TABLES} from "../../../../Apis/Tables";
import TableFunction from "../../../../components/table/TableFunction";
import DropDownMenuProfile from "../../../../components/DropDown/DropDownMenuProfile";
import DropDownMenuItem from "../../../../components/DropDown/DropDownMenuItem";
import routes from "../../../../Routes/routes";
import {clearZoneDetailFatherAndChild} from "../../../../reduxToolkit/EmployeeZones/EmployeeZoneSlice";
import {useNavigate} from "react-router-dom";
import CustomChip from "../../../../components/CustomChip";
import {statusBorderColor, statusColor, statusFontColor} from "../../../../enums/statusColorEnum";
import {status} from "../../../../enums/statusEnum";
import ButtonSubAction from "../../../../components/buttons/ButtonSubAction";
import {permissionObj} from "../../../../Helpers/permission";
import {SEARCH_MODEL} from "../../../../components/table/Model/TableModel";
import {
    DetailsIconsOptions,
    PlusIconsOptions
} from "../../../../components/buttons/IconButtons";
import {EMPTY_VALUES, errorMsg} from "../../../../Apis/functions";
import {SimpleSearch} from "../../../../reduxToolkit/Search/SearchApi";
import {VIEW_TYPE} from "../../../../enums/ViewType";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @JobTitle: Full Stack Developer
 *
 * @description
 * Custom hook `ZoneApp` for managing zones, including CRUD operations, pagination,
 * searching, and selection handling.
 *
 * @returns {Object} An object containing state and functions for zone management.
 */
export const ZoneApp = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [modalShow, setModalShow] = useState(false);
    const [deleteShow, setDeleteShow] = useState(false);
    const [childModalShow, setChildModalShow] = useState(false);
    const [simpleSearch, setSimpleSearch] = useState(false);
    const contractorId = sessionStorage.getItem('contractorId');
    const supplierId = sessionStorage.getItem('providerId');
    const [search, setSearch] = useState(false);
    const [searchElement, setSearchElement] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [bodyForExport, setBodyForExport] = useState();
    const option = TABLES.ZONE;
    const elementRef = useRef(null);

    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);

    const [modified,setModified] = useState(false)
    const [selectedList, setSelectedList] = useState([]);
    const [isFatherZone, setIsFatherZone] = useState({});
    const [expandedRowId, setExpandedRowId] = useState(null);
    sessionStorage.setItem('zonesStack', JSON.stringify([]));

    const handleRowExpand = (row) => {
        if (row?.id !== expandedRowId) {
            setExpandedRowId(row?.id);
        }
    };

    const renderOptionsMenu = (row,index) => {
        return (
            <>
                <DropDownMenuProfile openMenu={openMenu} handleMenuToggle={handleMenuToggle} menuId={`menu-${row?.id}`}>
                    <DropDownMenuItem
                        index={index}
                        handleClose={handleClose}
                        name={t('details')}
                        click={() => {
                            dispatch(clearZoneDetailFatherAndChild());
                            navigate(routes.zone.details + row?.id);
                            sessionStorage.setItem('zonesStack', JSON.stringify([{ id: row?.id, name: row?.name }]),);
                        }}
                        icon={ <DetailsIconsOptions/>}
                    />
                </DropDownMenuProfile>
            </>
        )
    };

    const columns = useMemo(()=> [
        {
            field: 'name',
            label: 'name',
            className: "w-40vw",
            classNameContainerTooltip: "w-40vw",
            render: (value,row) => {
                return {
                    text:  value,
                    subChip :
                        <>
                            {(DEV || permission?.includes(permissionObj?.WEB_ZONE_CREATE)) &&
                            <ButtonSubAction
                                id="btn_zc_add_sub_zone"
                                name="create_subzone"
                                Icon={PlusIconsOptions}
                                onClick={() => {
                                    setChildModalShow(true);
                                    setIsFatherZone({ id: row?.id, name: value });
                                }}
                            />
                            }
                        </>
                }
            }
        },
        {
            field: 'status',
            label: 'status',
            render: (value) => {
                return (
                    <CustomChip
                        background={statusColor[value?.id]}
                        fontColor={statusFontColor[value?.id]}
                        borderColor={statusBorderColor[value?.id]}
                        legend={t(status[value?.id]) || EMPTY_VALUES.DEFAULT} variant={'large'}
                    />
                );
            }
        }
    ],[])

    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = (page) => {
        const body = SEARCH_MODEL.setObject({
            page,
            size: rowsPerPage,
            model: option,
            key: searchElement,
            view: VIEW_TYPE.GRID.viewType,
        });

        setBodyForExport(body);
        dispatch(SimpleSearch({ body })).then(
            ({
                 payload: {
                     data: { data, success },
                 },
             }) => {
                if (success === true) {
                    setSearchResults(data);
                }
            },
        );
    }

    const {t,handleCheckboxChange, handleDeleteAll,handleMenuToggle,
        handleClose,openMenu,
        pagination, page, rowsPerPage} = TableFunction({
        selectedList,
        setSelectedList,
        data: searchResults,
        labelRowsPerPage:'zone_per_page',
        searchElement, //New
        getData,//New
        modified,//New
        setModified,//New
    });

    useEffect(() => {
        if (elementRef.current) {
            const rect = elementRef.current.getBoundingClientRect();
            const distanceTop = rect.top + 0;
            elementRef.current.style.setProperty('--top-value', `${distanceTop}px`);
        }
    }, []);

    /**
     * Deletes selected zones.
     * @param {Array} deleteItem - The list of zone IDs to delete.
     */
    const deleteZone = (deleteItem) => {
        const tableName = option;
        const body = deleteItem;
        dispatch(DeleteItemsApi({ tableName, body })).then(({payload: {data: { success, code },},}) => {
                if(success){
                    setSelectedList([]);
                    setModified(true);
                }else errorMsg(code)
            },
        );
    };

    return {
        setModalShow, setDeleteShow, searchElement, setSearchElement, setSearchResults, setBodyForExport,
        setSearch, simpleSearch, setSimpleSearch, contractorId, supplierId,
        handleDeleteAll, searchResults, modalShow, deleteShow, deleteZone,
        handleCheckboxChange, option,pagination,page,
        rowsPerPage,childModalShow,setChildModalShow,
        modified,
        setModified,
        columns,
        renderOptionsMenu,
        handleRowExpand,
        selectedList,
        isFatherZone,
        t,
        DEV,
        permission
    };
};
